import { SxProps, TextField } from "@mui/material";
import React, { useState } from "react";
import { MenuItemSuggestionCategory } from "../../../../types";
import SuggestionCategoryDialog from "./Dialog";
import { getSuggestionCategoryShortLabel } from "./utils";

interface MenuItemSuggestionCategorySelectProps {
  value: MenuItemSuggestionCategory | null;
  onChange?: (value: MenuItemSuggestionCategory | null) => void;
  disabled?: boolean;
  sx?: SxProps;
}

export const MenuItemSuggestionCategorySelect = ({ value, onChange, disabled, sx }: MenuItemSuggestionCategorySelectProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const openDialog = () => setDialogOpen(true);

  return (
    <>
      <TextField
        type="text"
        label="Category"
        value={getSuggestionCategoryShortLabel(value)}
        onClick={openDialog}
        onKeyDown={event => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openDialog();
          }
        }}
        disabled={disabled}
        sx={sx}
        inputProps={{
          readOnly: true,
          style: {
            caretColor: "transparent",
          },
        }}
      />
      {dialogOpen && onChange && (
        <SuggestionCategoryDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          value={value}
          onDone={onChange} />
      )}
    </>
  );
};
